/**
 * Common Icons - Shared SVG icons used across the app
 *
 * Extract duplicate icons here to avoid repetition.
 */

// Star icon used for winners/rankings
export const StarIcon = ({
  size = 14,
  filled = true,
}: {
  size?: number;
  filled?: boolean;
}) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none">
    <path
      d="M12 2L15.09 8.26L22 9.27L17 14.14L18.18 21.02L12 17.77L5.82 21.02L7 14.14L2 9.27L8.91 8.26L12 2Z"
      fill={filled ? '#D4AF37' : 'none'}
      stroke="#D4AF37"
      strokeWidth="1.5"
    />
  </svg>
);

// Chevron right icon for navigation/links
export const ChevronRightIcon = ({
  size = 18,
  color = 'currentColor',
}: {
  size?: number;
  color?: string;
}) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none">
    <path
      d="M9 18l6-6-6-6"
      stroke={color}
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

// Leaderboard icon
export const LeaderboardIcon = ({ size = 16 }: { size?: number }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none">
    <path
      d="M3 10h18M3 14h18M3 6h12M3 18h12"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
    />
  </svg>
);

// Info circle icon for tooltips
export const InfoIcon = ({
  size = 12,
  color = 'currentColor',
}: {
  size?: number;
  color?: string;
}) => (
  <svg width={size} height={size} viewBox="0 0 12 12" fill="none">
    <circle cx="6" cy="6" r="5" stroke={color} strokeWidth="1.2" />
    <path
      d="M6 5V8M6 3.8V3.5"
      stroke={color}
      strokeWidth="1.2"
      strokeLinecap="round"
    />
  </svg>
);

// Error/alert circle icon
export const AlertCircleIcon = ({
  size = 24,
  color = 'currentColor',
}: {
  size?: number;
  color?: string;
}) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    stroke={color}
    strokeWidth="2"
  >
    <circle cx="12" cy="12" r="10" />
    <line x1="12" y1="8" x2="12" y2="12" />
    <line x1="12" y1="16" x2="12.01" y2="16" />
  </svg>
);

// Chart/stats icon
export const ChartIcon = ({
  size = 16,
  color = 'currentColor',
}: {
  size?: number;
  color?: string;
}) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    stroke={color}
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    <polyline points="22 12 18 12 15 21 9 3 6 12 2 12" />
  </svg>
);
